

module.exports = function($scope, types){
  $scope.types = types;

  $scope.cancel = function(e) {
    e.preventDefault();
    $scope.closeThisDialog({action:'cancel'});
  }

    $scope.submit = function () {
    $scope.closeThisDialog({
      action: 'submit',
      data: {
        socialMediaType: $scope.type,
        socialMediaUrl: $scope.url,
        socialMediaNumber: $scope.smNumber
      }
    })
  }
}
